import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './edit';
import Save from './save';

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: '#0061FE',
    src: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
      >
        {/* Three ticks, each with its line of text */}
        <path d="M2.2 6.3l1.1-1.1 1.3 1.3 2.4-2.4 1.1 1.1L4.6 8.7 2.2 6.3z" />
        <rect x="10" y="5" width="12" height="1.8" rx="0.9" />
        <path d="M2.2 12.3l1.1-1.1 1.3 1.3 2.4-2.4 1.1 1.1-3.5 3.5-2.4-2.4z" />
        <rect x="10" y="11" width="12" height="1.8" rx="0.9" />
        <path d="M2.2 18.3l1.1-1.1 1.3 1.3 2.4-2.4 1.1 1.1-3.5 3.5-2.4-2.4z" />
        <rect x="10" y="17" width="12" height="1.8" rx="0.9" />
      </svg>
    ),
  },
});
